import { render, staticRenderFns } from "./VuesticTreeNode.vue?vue&type=template&id=44b3f842"
import script from "./VuesticTreeNode.vue?vue&type=script&lang=js"
export * from "./VuesticTreeNode.vue?vue&type=script&lang=js"
import style0 from "./VuesticTreeNode.vue?vue&type=style&index=0&id=44b3f842&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-tree-view/VuesticTreeNode.vue
// module id = IkPp
// module chunks = 41